import { AppShell, Text } from '@mantine/core';
import { Outlet } from 'react-router-dom';

/**
 * アプリケーション全体のレイアウトコンポーネント
 *
 * メインコンテンツエリアと、画面下部にアプリバージョンを表示する極小フッタを含む。
 * フッタは fixed position で右下にオーバーレイするため、既存ページの `100vh` 指定を
 * 乱さない。
 */
export function AppLayout() {
  return (
    <AppShell padding={0}>
      <AppShell.Main>
        <Outlet />
      </AppShell.Main>
      <Text
        size="10pt"
        c="dimmed"
        style={{
          position: 'fixed',
          left: '50%',
          bottom: 10,
          transform: 'translateX(-50%)',
          zIndex: 1,
          pointerEvents: 'none',
          opacity: 0.8,
        }}
      >
        v{__APP_VERSION__}
      </Text>
    </AppShell>
  );
}
